import { logger } from '@/lib/logging'
import type { SessionRefs } from './types'

export function stopTracks(stream: MediaStream | null) {
  stream?.getTracks().forEach((track) => track.stop())
}

export async function closeAudioMixing(refs: SessionRefs) {
  stopTracks(refs.mixedAudioStreamRef.current)
  refs.mixedAudioStreamRef.current = null

  if (refs.audioMixingContextRef.current) {
    try {
      await refs.audioMixingContextRef.current.close()
    } catch (err) {
      logger.warn('Error closing audio mixing context', { error: String(err) })
    }
    refs.audioMixingContextRef.current = null
  }
}

export async function restoreCameraFeed(refs: SessionRefs) {
  if (!refs.videoRef.current || !refs.mediaStreamRef.current) return

  refs.videoRef.current.srcObject = refs.mediaStreamRef.current
  try {
    await refs.videoRef.current.play()
  } catch (err) {
    logger.warn('Error restoring camera feed', { error: String(err) })
  }
}
